
define(
	'Tavano.TT3CXLiveChat.Snippet'
	, [

	]
	, function (

	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {

				var self = this;
				var layout = container.getLayout();

				/** @type {EnvironmentComponent} */
				var environmentComponent = container.getComponent('Environment');

				layout.once('afterAppendView', function (view) {

					/**Finshing execution when SSR - Server Side Rendering or SEO */
					if (environmentComponent.isPageGenerator()) {
						return;
					}else{
						self.loadSnippet();
					}

				})

			},
			loadSnippet: function () {

				// Create and append the 3CX Live Chat script
				var script = document.createElement('script');
				script.defer = true;
				script.src = 'https://downloads-global.3cx.com/downloads/livechatandtalk/v1/callus.js';
				script.id = 'tcx-callus-js';
				script.charset = 'utf-8';
				document.head.appendChild(script);

				// Create and append the <call-us-selector> element
				var callUsSelector = document.createElement('call-us-selector');
				callUsSelector.setAttribute('phonesystem-url', 'https://lapwing.3cx.uk');
				callUsSelector.setAttribute('party', 'LiveChat158547');

				document.head.appendChild(callUsSelector);

			}
		};
	});
